import {
    PostContactRequest
} from "../repositories/contact_repository";

export const ContactService = () => {
    const createContact = async (contactDetails, setContactList, setErrors) => {
        try {
            const response = await PostContactRequest(contactDetails);
            if (response?.success) {
                setContactList((prevList) => [...prevList, response.data]);
                return true;
            } else {
                setErrors(response?.errors || {general : "Failed to create Contact."});
                return false;
            }
        } catch (error) {

            return false;
        }
    };

    return {
        createContact,
    };
};